import { axiosClient } from '../axiosClient';

// Chaves de permissão (áreas) — espelham o backend (config/permissions.js).
export type Permission =
  | 'dashboard'
  | 'devices'
  | 'errors'
  | 'logs'
  | 'users'
  | 'plans'
  | 'finance'
  | 'support'
  | 'uptime'
  | 'settings'
  | 'team'
  | 'careers'
  | 'orcamentos'
  | 'notifications';

export type LoginRequest = {
  email: string;
  password: string;
};

export type Manager = {
  id: number;
  name: string;
  email: string;
  role: string; // legado (compat)
  roles: string[];
  permissions: Permission[];
  must_change_password: boolean;
  created_at?: string;
  last_login?: string;
};

export type LoginResponse = {
  token: string;
  manager: Manager;
};

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await axiosClient.post<LoginResponse>('/manager/auth/login', credentials);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await axiosClient.post('/manager/auth/logout');
  },

  getMe: async (): Promise<{ manager: Manager }> => {
    const response = await axiosClient.get<{ manager: Manager }>('/manager/auth/me');
    return response.data;
  },

  changePassword: async (data: {
    current_password: string;
    new_password: string;
  }): Promise<void> => {
    await axiosClient.post('/manager/auth/change-password', data);
  },
};
